import { observer } from 'mobx-react-lite'
import { createViewModel } from 'mobx-utils'
import { Participant } from '../../../datastores/participant'
import React from 'react'
import { Button, ParticipantView as EditParticipant } from './participantView'
import cuid from 'cuid'
import Translator from '../../translator'
import PropTypes from 'prop-types'
import { runInAction } from 'mobx'

/** @type import('React').FC<{ p:ParticipantsViewModel, eventGroups:EventGroup[], displayExisting:bool }>*/
const _Participants = ({ p, eventGroups , displayExisting}) => {

  const min_spots_left = Math.min(
      ...eventGroups.map(event_group => {
        if(!displayExisting) {
          return event_group.spots_left - event_group.participants.length
        }

        return event_group.spots_left
      })
  )

  return (
    <div className='participants-modal-content'>
      {min_spots_left > 0 ? (
        <div className='participants-modal-grid'>
          {p.ps.map((p_, index) => (
            <EditParticipant
              p={p_}
              key={p_.id}
              index={index}
              eventGroups={eventGroups}
              onDelete={() => {
                p.delete(p_)
              }}
            />
          ))}
        </div>
      ) : null}
      {
        min_spots_left - p.ps.length > 0 ? (
        <Button
          onClick={() => {
            runInAction(() => {
              p.ps.push(createViewModel(new Participant(cuid())))
            })
          }}
          className='button mtt-add-button'
        >
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
            <path d='M10,1.5A8.5,8.5,0,1,0,18.5,10,8.51,8.51,0,0,0,10,1.5M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z' />
            <g transform='translate(6.667 6.667)'>
              <path
                d='M6.667.75H0V-.75H6.667Z'
                transform='translate(0 3.333)'
              />
              <path d='M.75,6.667H-.75V0H.75Z' transform='translate(3.333)' />
            </g>
          </svg>
          {Translator.translate('Tilføj deltager', 'participant')}
        </Button>
      ) : (
        <div className={'button mtt-add-button'}>
          {Translator.translateNumber(
            'Du kan ikke tilføje flere deltagere, da holdet ikke har flere pladser',
            'Du kan ikke tilføje flere deltagere, da én eller flere hold ikke har flere pladser',
            eventGroups.length,
            'participant'
          )}
        </div>
      )}
    </div>
  )
}
_Participants.propTypes = {
  p: PropTypes.object.isRequired,
  eventGroups: PropTypes.array.isRequired
}
export const Participants = observer(_Participants)
